import React, { FC } from 'react';
import HyperLink, { ENTITY_TYPE } from '../common/HyperLink';

const WalkthroughTaskWithWorkOrderMessage: FC<any> = ({
	linkedWorkOrderId,
}): React.ReactElement => {
	return (
		<div className="flex flex-col gap-2">
			<div className="bodyregular">
				This task is linked to a work order and can be managed there.
			</div>
			<HyperLink
				entityType={ENTITY_TYPE.WORK_ORDER}
				entityId={linkedWorkOrderId}
				text="Go to work order"
			/>
		</div>
	);
};

export default WalkthroughTaskWithWorkOrderMessage;
